(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-furgo-pdp]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const radios = [...root.querySelectorAll('[data-pdp-variant]')];
      const thumbnails = [...root.querySelectorAll('[data-pdp-image]')];
      const mainImage = root.querySelector('.pdp-main-image');
      const galleryStatus = root.querySelector('[data-pdp-gallery-status]');
      const form = root.querySelector('[data-pdp-form]');
      const button = root.querySelector('[data-pdp-add]');
      const feedback = root.querySelector('[data-pdp-feedback]');
      const bag = root.querySelector('[data-pdp-bag]');
      const dialog = root.querySelector('[data-pdp-dialog]');
      const imageInDialog = dialog.querySelector('img');
      const selectImage = (thumb, announce = true) => {
        if (!thumb) return;
        mainImage.src = thumb.dataset.pdpImage;
        mainImage.srcset = thumb.dataset.pdpSrcset;
        mainImage.alt = thumb.dataset.pdpAlt;
        imageInDialog.src = thumb.dataset.pdpImage;
        imageInDialog.removeAttribute('srcset');
        imageInDialog.alt = thumb.dataset.pdpAlt;
        thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
        if (announce) galleryStatus.textContent = thumb.dataset.pdpAlt;
      };
      thumbnails.forEach(thumb => thumb.addEventListener('click', () => selectImage(thumb)));
      const updateButton = () => {
        if (!button) return;
        const chosen = radios.find(r => r.checked);
        const busy = form.dataset.busy === 'true';
        button.disabled = busy || !chosen || chosen.dataset.available !== 'true';
        button.textContent = busy ? button.dataset.adding : (chosen?.dataset.available === 'true' ? button.dataset.add : button.dataset.sold);
      };
      const syncVariant = (radio, writeHistory = false, announce = false) => {
        if (!radio) return;
        radio.checked = true;
        root.querySelector('[data-pdp-title]').textContent = radio.dataset.title;
        root.querySelector('[data-pdp-intro]').textContent = radio.dataset.intro;
        root.querySelector('[data-pdp-included]').textContent = radio.dataset.included;
        root.querySelectorAll('[data-pdp-price]').forEach(el => el.textContent = radio.dataset.price);
        root.querySelector('[data-pdp-mobile-title]').textContent = radio.closest('label').querySelector('strong').textContent;
        const saving = root.querySelector('[data-pdp-saving]');
        if (saving) saving.hidden = radio.dataset.imageIndex !== '1';
        selectImage(thumbnails.find(t => t.dataset.imageIndex === radio.dataset.imageIndex), announce);
        if (writeHistory) {
          const url = new URL(location.href);
          url.searchParams.set('variant', radio.value);
          history.pushState({variant:radio.value}, '', url);
        }
        updateButton();
      };
      radios.forEach(radio => radio.addEventListener('change', () => syncVariant(radio, true, true)));
      const fromUrl = () => {
        const id = new URL(location.href).searchParams.get('variant');
        syncVariant(radios.find(r => r.value === id) || radios[0]);
      };
      const initialId = new URL(location.href).searchParams.get('variant');
      syncVariant(radios.find(r => r.value === initialId) || radios.find(r => r.checked) || radios[0]);
      const lifecycle = new AbortController();
      addEventListener('popstate', fromUrl, {signal:lifecycle.signal});
      const zoomTrigger = root.querySelector('[data-pdp-zoom-open]');
      zoomTrigger.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); });
      root.querySelector('[data-pdp-zoom-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => zoomTrigger.focus({preventScroll:true}));
      const mobileBar = root.querySelector('[data-pdp-mobile-bar]');
      const primary = button || root.querySelector('[data-pdp-primary]');
      let observer;
      let scrollFrame;
      if (primary && mobileBar) {
        const updateMobileBar = () => { scrollFrame = undefined; mobileBar.hidden = primary.getBoundingClientRect().bottom > 0; };
        const scheduleMobileBar = () => { if (scrollFrame === undefined) scrollFrame = requestAnimationFrame(updateMobileBar); };
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(updateMobileBar);
          observer.observe(primary);
        }
        addEventListener('scroll', scheduleMobileBar, {passive:true,signal:lifecycle.signal});
        addEventListener('resize', scheduleMobileBar, {passive:true,signal:lifecycle.signal});
        updateMobileBar();
      }
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) { observer?.disconnect(); cancelAnimationFrame(scrollFrame); lifecycle.abort(); } }, {signal:lifecycle.signal});
      if (!button) return;
      form.noValidate = true;
      const quantity = form.querySelector('[name=quantity]');
      quantity.addEventListener('input', () => quantity.removeAttribute('aria-invalid'));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.busy || button.disabled) return;
        if (!quantity.validity.valid || !Number.isInteger(quantity.valueAsNumber)) {
          feedback.textContent = feedback.dataset.quantityError;
          quantity.setAttribute('aria-invalid', 'true');
          quantity.focus();
          return;
        }
        const payload = new FormData(form);
        payload.set('sections', 'furgo-cart-drawer');
        payload.set('sections_url', location.pathname);
        form.dataset.busy = 'true';
        root.querySelector('.pdp-options').disabled = true;
        form.querySelector('[name=quantity]').disabled = true;
        button.setAttribute('aria-busy', 'true');
        updateButton();
        feedback.textContent = '';
        bag.hidden = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        const base = window.Shopify?.routes?.root || '/';
        let safeError = feedback.dataset.error;
        try {
          const response = await fetch(base + 'cart/add.js', {method:'POST',body:payload,headers:{Accept:'application/json'},signal:controller.signal});
          const data = await response.json();
          if (!response.ok) { if (typeof data.description === 'string') safeError = data.description; throw new Error('Cart rejected'); }
          feedback.textContent = feedback.dataset.success;
          bag.hidden = false;
          if (window.FurgoCart) window.FurgoCart.open({trigger:button,html:data.sections?.['furgo-cart-drawer'],added:true});
        } catch {
          feedback.textContent = safeError;
          bag.hidden = false;
        } finally {
          clearTimeout(timeout);
          delete form.dataset.busy;
          root.querySelector('.pdp-options').disabled = false;
          form.querySelector('[name=quantity]').disabled = false;
          button.removeAttribute('aria-busy');
          updateButton();
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

